import moduleConfig from './advertisement.config'

export default [
  {
    path: moduleConfig.basePath,
    component: () => import('./advertisement.module'),
    children: []
  }
]
